import {useContrato} from "@components/contratos/hooks/useContrato.tsx";
import React from "react";
import {NavButton, NavButtonProps} from "@shared/custom/NavButton.tsx";
import {IContrato} from "@models/contratos/contrato.ts";

interface ContratoInfoNavLinkProps extends Omit<NavButtonProps<IContrato>, 'value'> {
    value: IContrato | number;
}

export function ContratoInfoNav(props: ContratoInfoNavLinkProps) {
    const {useContratoValue} = useContrato()
    const [value] = useContratoValue(props.value)

    const handleCtx = (_e: React.MouseEvent<HTMLElement>) => {
        // if (value == null) return
        return null
    }


    return (value != null && <NavButton
        pathname={'/contratos/detalhes'}
        onContextMenu={handleCtx}
        hint={"Ir para a pagina de detalhes do contrato " + value.nome}
        onClick={props.onClick}
        displayMode={'nome'}
        permissoesNecessarias={['VisualizarContratos']}
        searchData={{contratoId: value.id}}
        {...props}
        value={typeof props.value != "number" ? props.value : value}
    />)


    /*pathName={'/contratos/detalhes'}
                                               searchData={{contratoId: value.id}}
                                               toolTipHint={"Ir para a pagina de detalhes do contrato " + value.nome}
                                               chipSx={{...props.slotProps?.chip?.sx}}
                                               tableMode={props.slotProps?.chip?.tableMode}
                                               permissoesNecessarias={['VisualizarContratos']}
                                               label={(v)=>value.nome}/>);*/
}